import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Typography from '@components/_mui/Typography'

export default function Field({ label, value, isLoading = false, labelWidth, sx }) {
  const gridTemplateColumns = labelWidth ? `${labelWidth}px minmax(0, 1fr)` : columns

  return (
    <Box sx={[styles.field, { gridTemplateColumns }, sx]}>
      <Typography sx={{ color: 'text.secondary' }}>{label}</Typography>
      <Value value={value} isLoading={isLoading} />
    </Box>
  )
}

function Value({ value, isLoading }) {
  if (isLoading) {
    return (
      <Typography>
        <Skeleton width={120} />
      </Typography>
    )
  }

  if ([null, undefined, '', false].includes(value)) {
    return <Typography sx={{ color: 'text.secondary' }}>-</Typography>
  }

  if (['string', 'number'].includes(typeof value)) {
    return <Typography sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{value}</Typography>
  }

  return value
}

const columns = { xs: 'minmax(0, 1fr)', sm: '160px minmax(0, 1fr)', lg: '220px minmax(0, 1fr)' }

const styles = {
  field: {
    display: 'grid',
    columnGap: 2,
    alignItems: 'start',
  },
}
